import React from 'react';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
import {Checkbox, Input, ListScreen, Select} from '../components';
import {
    fetchAiCommands,
    cleanAiCommands,
    setUser,
    changeUserSetting,
    commentAiCommand,
    deleteAiCommand,
} from '../actions';
import {__, formatAmount, formatDate, getCurrency, isEmptyString, request, toNumber} from '../functions';
import '../assets/styles/ai-commands.css';
import {
    AI_FUNCTION_NAMES,
    AI_TRANSLATE_CATEGORY_INPUTS,
    AI_TRANSLATE_FUNCTION_SLUG,
    AI_TRANSLATE_PRODUCT_INPUTS
} from '../config';
import ViewIcon from '@mui/icons-material/Folder';
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {ButtonBase, Tooltip} from "@mui/material";
import AddIcon from "@mui/icons-material/AddCircle";
import CopyIcon from '@mui/icons-material/FileCopy';
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";

class AiCommandsScreen extends ListScreen {
    title = __('AI úlohy');

    state = { ...ListScreen.state, ...{
        lightbox: {
            comment: false,
            delete: false,
            upload: false,
        },
    }};

    excelColumns = { A: 'A', B: 'B', C: 'C', D: 'D', E: 'E', F: 'F', G: 'G', H: 'H', I: 'I', J: 'J', K: 'K', L: 'L', M: 'M', N: 'N', O: 'O', P: 'P', Q: 'Q', R: 'R', S: 'S', T: 'T', U: 'U', V: 'V', W: 'W', X: 'X', Y: 'Y', Z: 'Z' };
    csvColumns = { 0: '0', 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8', 9: '9', 10: '10', 11: '11', 12: '12', 13: '13', 14: '14', 15: '15', 16: '16', 17: '17', 18: '18', 19: '19', 20: '20', 21: '21', 22: '22', 23: '23', 24: '24', 25: '25' };

    isValidPermission() {
        return this.hasPermission('aicommands');
    }

    getTableName() {
        return 'ai-commands';
    }

    getListClassName() {
        return 'list-ai-commands';
    }

    getFilter() {
        const { items } = this.props;

        return _.reduce(items.filter, (result, options, key) => {
            switch (key) {
                case 'ai_function_id':
                    return { ...result, ...{ [key]: {
                        type: 'select',
                        name: __('AI funkcia'),
                        value: '',
                        options: _.reduce(options, (result, name, id) => {
                            return { ...result, [id]: _.has(AI_FUNCTION_NAMES, name) ? AI_FUNCTION_NAMES[name] : name };
                        }, {}),
                    }}};

                default:
                    return result;
            }
        }, {})
    }

    getColumns() {
        return [
            <div>{__('Funkcia')}</div>,
            <div>{__('Poznámka')}</div>,
            <div>{__('Stav')}</div>,
            <div>{__('Počet položiek')}</div>,
            <div>{__('Cena')}</div>,
            <div>{__('Vytvorené')}</div>,
            <div></div>,
        ];
    }

    getCells(item) {
        const { items } = this.props;

        let category = null;
        let language = null;
        let translateField = null;

        const name = item._matchingData.AiFunctions.name;
        const isDefault = toNumber(item._matchingData.AiFunctions.def) === 1;

        if (isDefault) {
            category = <div className="category" style={{ backgroundColor: '#c8c4c4' }}>{__('System')}</div>;
        }

        if (_.has(item.settings, 'language')) {
            language = <div className="category" style={{ backgroundColor: '#459350' }}>{item.settings.language}</div>;
        }

        if (_.has(item.settings, 'translate_field')) {
            let translate_field_name = item.settings.translate_field;

            if (_.has(AI_TRANSLATE_PRODUCT_INPUTS, item.settings.translate_field)) {
                translate_field_name = AI_TRANSLATE_PRODUCT_INPUTS[item.settings.translate_field];
            } else if (_.has(AI_TRANSLATE_CATEGORY_INPUTS, item.settings.translate_field)) {
                translate_field_name = AI_TRANSLATE_CATEGORY_INPUTS[item.settings.translate_field];
            }

            translateField = <div className="category category-translate-field" style={{ backgroundColor: '#5c70ff' }}>{translate_field_name}</div>;
        }

        let status = <span style={{ color: '#459350' }}>{__('Spracované')}</span>;

        switch (item.status) {
            case 'processing':
            case 'waiting':
                status = <span style={{ color: '#ff9931' }}>{__('Spracováva sa')}</span>;
                break;

            case 'draft':
                status = <span style={{ color: '#b8b22c' }}>{__('Čaká na spustenie')}</span>;
                break;
        }

        const functionName = isDefault && _.has(AI_FUNCTION_NAMES, name) ? AI_FUNCTION_NAMES[name] : name;

        const is_products = item.items_type === 'product';
        const is_categories = item.items_type === 'category';

        return [
            <div>
                <div>
                    <div><Tooltip title={functionName}><span>{_.truncate(functionName, { length: 48 })}</span></Tooltip></div>
                </div>
                <div>
                    {category}
                    {language}
                    {translateField}
                </div>
            </div>,
            <div>{item.comment !== null && item.comment !== '' ? <Tooltip title={item.comment}><span>{_.truncate(item.comment, { length: 36 })}</span></Tooltip> : '-'}</div>,
            <div>{status}</div>,
            <div>{item.items}</div>,
            <div>{formatAmount(item.price, 'EUR', 8)}</div>,
            <div>{formatDate(item.created, 'dd.mm.yyyy hh:ii')}</div>,
            <div>
                {this.renderTableButton(
                    item.id,
                    __('Zobraziť'),
                    <ViewIcon />,
                    (callbackLoading, callback) => this.redirect(`/ai-commands/view/${item.id}`),
                    {}
                )}
                {this.renderTableButton(
                    item.id,
                    is_categories ? __('Vytvoriť novú úlohu s kategóriami v tejto úlohe') : __('Vytvoriť novú úlohu s produktami v tejto úlohe'),
                    <CopyIcon />,
                    (callbackLoading, callback) => this.redirect(is_categories ? `/products/categories/copy-ai/${item.id}` : `/products/copy-ai/${item.id}`),
                    { disabled: (item.attachment !== null && item.attachment !== '') || (!is_products && !is_categories) }
                )}
                {this.renderTableButton(
                    item.id,
                    __('Poznámka'),
                    <EditIcon />,
                    (callbackLoading, callback) => this.confirmComment(item.id, _.toString(item.comment), callbackLoading, callback),
                    {}
                )}
                {this.renderTableButton(
                    item.id,
                    __('Zmazať'),
                    <DeleteIcon />,
                    (callbackLoading, callback) => this.confirmDelete(item.id, callbackLoading, callback),
                    {}
                )}
            </div>,
        ];
    }

    confirmDelete(id, callbackLoading, callback) {
        this.showLightbox('delete', { id, callbackLoading, callback });
    }

    confirmComment(id, comment, callbackLoading, callback) {
        this.showLightbox('comment', { id, comment, callbackLoading, callback });
    }

    onChangeComment(type, value) {
        const { lightbox } = this.state;

        this.setState({ lightbox: { ...lightbox, comment: { ...lightbox.comment, [type]: value } } });
    }

    getTags() {
        const { user, items } = this.props;

        return [
            {
                name: __('Nová úloha'),
                onClick: () => this.showLightbox('upload', {
                    loading: false,
                    data: {
                        slug: '',
                        name: '',
                        file: null,
                        import_setting_skip: false,
                        import_setting_cell: '',
                        variable_language: '',
                    },
                }),
                color: 'secondary',
                icon: <AddIcon />,
                disabled: this.isDemo() || toNumber(user.user_eshop_id) === 0,
            },
            {
                name: `${__('Aktuálny kredit')}: ${formatAmount(items.credit, 'EUR', 4)}`,
                color: 'secondary',
                onClick: () => this.redirect('/ai-transactions'),
                icon: <MonetizationOnIcon />,
            },
            {
                name: __('Dobiť kredit'),
                color: 'secondary',
                onClick: () => this.redirect('/ai-transactions'),
                icon: <AddIcon />,
                className: 'ai-credit-tag',
            },
            { name: __('Úlohy budú automatické zmazané po 30 dňoch od spracovania.'), className: 'ai-commands-delete-info', },
        ];
    }

    getEmptyText() {
        return __('Zatiaľ nemáte žiadne úlohy');
    }

    onChangeUpload(key, value) {
        const { items } = this.props;
        const { lightbox } = this.state;

        let additional = {};

        if (key === 'file' && typeof value.name !== 'undefined' && isEmptyString(lightbox.upload.data.name)) {
            additional = { name: value.name.toString().replace(/\.[^/.]+$/, '') };
        } else if (key === 'slug' && value === AI_TRANSLATE_FUNCTION_SLUG) {
            const { ai_functions_variables } = items;

            additional = { variable_language: ai_functions_variables[AI_TRANSLATE_FUNCTION_SLUG].language.default };
        }

        this.setState({ lightbox: { ...lightbox, upload: {
            ...lightbox.upload,
            data: { ...lightbox.upload.data, [key]: value, ...additional }
        } } });
    }

    onChangeUploadLoading(value) {
        const { lightbox } = this.state;

        this.setState({ lightbox: { ...lightbox, upload: { ...lightbox.upload, loading: value } } })
    }

    async upload() {
        const { lightbox } = this.state;

        if (lightbox.upload.data.file === null) {
            this.showSnackbar('error', __('Nie je nahratý súbor'));
            return;
        } else if (isEmptyString(lightbox.upload.data.slug)) {
            this.showSnackbar('error', __('Nie je vybraná AI funkcia'));
            return;
        }

        let variable_language = '';

        if (!_.isEmpty(lightbox.upload.data.variable_language)) {
            variable_language = lightbox.upload.data.variable_language;
        }

        this.onChangeUploadLoading(true);

        request(`/ai-commands/upload/${lightbox.upload.data.slug}`, lightbox.upload.data.file, 'FILE', {
            variable_language,
            skip_first_row: lightbox.upload.data.import_setting_skip ? '1' : '0',
            input_cell: lightbox.upload.data.import_setting_cell,
        }).then(response => {
            const { status, data } = response.data;

            if (status === 'error') {
                this.onChangeUploadLoading(false);
                this.showSnackbar('error', __('Súbor sa nepodarilo nahrať'));
                return;
            }

            window.location = `/ai-commands/view/${data.command_id}`;
        });
    }

    async delete() {
        const { deleteAiCommand, items } = this.props;
        const { lightbox } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('Úlohu nie je možné zmazať na DEMO účte'))
            this.closeLightbox('delete');
            return;
        }

        // Zavolame loading
        lightbox.delete.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('delete');

        // Zmazeme
        await deleteAiCommand(this, lightbox.delete.id);

        // Zavolame callback
        lightbox.delete.callback();

        // Znovu nacitame zoznam od prvej stranky
        this.fetchList(1, 0, items.filtered);
    }

    async comment() {
        const { commentAiCommand } = this.props;
        const { lightbox } = this.state;

        if (this.isDemo()) {
            this.showSnackbar('error', __('K úlohe nie je možné pridať poznámku na DEMO účte'))
            this.closeLightbox('comment');
            return;
        }

        // Zavolame loading
        lightbox.comment.callbackLoading();

        // Zavrieme lightbox
        this.closeLightbox('comment');

        // Zmazeme
        await commentAiCommand(this, lightbox.comment.id, lightbox.comment.comment);

        // Zavolame callback
        lightbox.comment.callback();
    }

    isExcel(file) {
        if (file === null) {
            return false;
        }

        const file_name = file.name.toString();

        if (file_name.indexOf('.csv') !== -1) {
            return true;
        } else if (file_name.indexOf('.xls') !== -1) {
            return true;
        }  else if (file_name.indexOf('.xlsx') !== -1) {
            return true;
        }

        return false;
    }

    getImportColumns(file) {
        if (file === null) {
            return {};
        }

        return file.name.toString().indexOf('.csv') !== -1 ? this.csvColumns : this.excelColumns;
    }

    renderUploadLightbox() {
        const { items } = this.props;
        const { lightbox } = this.state;

        if (lightbox.upload.loading) {
            return this.renderLoading(20);
        }

        const ai_functions = _.reduce(items.ai_functions, (result, item) => {
            return { ...result, [item.slug]: toNumber(item.def) > 0 && _.has(AI_FUNCTION_NAMES, item.name) ? AI_FUNCTION_NAMES[item.name] : item.name };
        }, {});

        const { ai_functions_variables } = items;

        let translateContent = null;

        const allowTranslate = lightbox.upload.data.slug === AI_TRANSLATE_FUNCTION_SLUG
            && _.has(ai_functions_variables, AI_TRANSLATE_FUNCTION_SLUG)
            && !_.isEmpty(ai_functions_variables[AI_TRANSLATE_FUNCTION_SLUG]);

        if (allowTranslate) {
            translateContent = (
                <div>
                    <Select
                        label={__('Jazyk')}
                        options={ai_functions_variables[AI_TRANSLATE_FUNCTION_SLUG].language.options}
                        value={lightbox.upload.data.variable_language}
                        onChange={value => this.onChangeUpload('variable_language', value)}
                    />
                </div>
            );
        }

        return (
            <div className="upload-ai-command">
                <div className="upload-ai-command__upload-text">{__('Súbor')}</div>
                <ButtonBase className="upload-ai-command__upload">
                    <div className="upload-ai-command__upload__text">{lightbox.upload.data.file !== null
                        ? lightbox.upload.data.file.name
                        : __('Kliknite alebo presuňte súbor (csv, xls, po, max. 5MB)')}</div>
                    <input type="file" onChange={event => this.onChangeUpload('file', event.target.files[0])} />
                </ButtonBase>
                {this.isExcel(lightbox.upload.data.file) ? <Select
                    label={__('Názov stĺpca v ktorom sa nachádzajú vstupné dáta')}
                    options={this.getImportColumns(lightbox.upload.data.file)}
                    value={lightbox.upload.data.import_setting_cell}
                    onChange={value => this.onChangeUpload('import_setting_cell', value)}
                /> : null}
                {this.isExcel(lightbox.upload.data.file) ? <Checkbox
                    label={__('Preskočiť prvý riadok')}
                    value={lightbox.upload.data.import_setting_skip}
                    onChange={checked => this.onChangeUpload('import_setting_skip', checked)}
                /> : null}
                <Select
                    label={__('AI funkcia')}
                    options={ai_functions}
                    value={lightbox.upload.data.slug}
                    onChange={value => this.onChangeUpload('slug', value)}
                />
                {translateContent}
            </div>
        );
    }

    renderScreen() {
        const { lightbox } = this.state;

        return (
            <div>
                {this.renderLightbox(
                    'upload',
                    __('Nová úloha'),
                    !_.isEmpty(lightbox.upload) ? this.renderUploadLightbox() : null,
                    __('Vytvoriť'),
                    __('Zrušiť'),
                    () => this.upload()
                )}
                {this.renderLightbox(
                    'comment',
                    __('Poznámka k úlohe'),
                    !_.isEmpty(lightbox.comment) ? (<div>
                        <Input
                            label={__('Poznámka')}
                            value={lightbox.comment.comment}
                            onChange={value => this.onChangeComment('comment', value)}
                        />
                    </div>) : null,
                    __('Uložiť'),
                    __('Zrušiť'),
                    () => this.comment()
                )}
                {this.renderLightbox(
                    'delete',
                    __('Naozaj chcete zmazať túto úlohu?'),
                    null,
                    __('Áno'),
                    __('Nie'),
                    () => this.delete()
                )}
            </div>
        );
    }
}

const stateToProps = ({ ai_commands, user }) => ({ items: ai_commands, user });

export default withCookies(connect(stateToProps, {
    fetch: fetchAiCommands,
    clean: cleanAiCommands,
    setUser,
    changeUserSetting,
    commentAiCommand,
    deleteAiCommand,
})(AiCommandsScreen));
